import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Stack } from '@mui/material';
import { FoodPartnerOrderStatusEnum } from '../../../../../../core/enums/inventory/food_partner_order';
import { SubmitButton } from '../../../../../common/button';
import { updateFoodPartnerOrderStatusAction, updateFoodPartnerOrderStatusState } from '../../../../../../features/inventory/update_food_partner_order_status';
import { getFoodPartnerOrderNotificationData, updateFoodPartnerOrderStatusNotificationData } from '../../../../../../core/utils/notification_utils';
import useNotification from '../../../../../../core/hooks/use_notification';
import { ApiRequestStatusEnum } from '../../../../../../core/enums/common/api';
import { getFoodPartnerOrderAction } from '../../../../../../features/inventory/get_food_partner_order';

const UpdateStatusButtons = ({ foodPartnerOrderStatus, foodPartnerOrderId }) => {
    const dispatch = useDispatch();
    const { showErrorMessage, showNotification } = useNotification();

    const updateFoodPartnerOrderStatus = useSelector(updateFoodPartnerOrderStatusState);

    const onUpdateFoodPartnerOrderStatus = (foodPartnerOrderNewStatus) => {
        dispatch(updateFoodPartnerOrderStatusAction({ id: foodPartnerOrderId, status: foodPartnerOrderNewStatus }))
            .then(response => {
                showNotification(updateFoodPartnerOrderStatusNotificationData(response));

                if (response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED) {
                    dispatch(getFoodPartnerOrderAction(foodPartnerOrderId))
                        .then(response => showErrorMessage(getFoodPartnerOrderNotificationData(response)));
                }
            });
    };

    if (foodPartnerOrderStatus === FoodPartnerOrderStatusEnum.GENERATING_DOCUMENTS.value) {
        return (
            <Stack direction="row" spacing={ 2 }>
                Trwa generowanie dokumentów...
            </Stack>
        )
    }

    if (![FoodPartnerOrderStatusEnum.CREATED.value, FoodPartnerOrderStatusEnum.IN_PROGRESS.value, FoodPartnerOrderStatusEnum.DELIVERED.value].includes(foodPartnerOrderStatus)) {
        return null;
    }

    return (
        <Stack direction="row" spacing={ 2 }>
            {
                foodPartnerOrderStatus === FoodPartnerOrderStatusEnum.CREATED.value && (
                    <>
                        <SubmitButton
                            type="button"
                            onClick={ () => onUpdateFoodPartnerOrderStatus(FoodPartnerOrderStatusEnum.IN_PROGRESS.value) }
                            isLoading={ updateFoodPartnerOrderStatus?.loading }
                        >
                            Zmień status na "w realizacji"
                        </SubmitButton>
                        <SubmitButton
                            type="button"
                            onClick={ () => onUpdateFoodPartnerOrderStatus(FoodPartnerOrderStatusEnum.DELIVERED.value) }
                            isLoading={ updateFoodPartnerOrderStatus?.loading }
                        >
                            Zmień status na "dostarczone"
                        </SubmitButton>
                    </>
                )
            }
            {
                foodPartnerOrderStatus === FoodPartnerOrderStatusEnum.IN_PROGRESS.value && (
                    <SubmitButton
                        type="button"
                        onClick={ () => onUpdateFoodPartnerOrderStatus(FoodPartnerOrderStatusEnum.DELIVERED.value) }
                        isLoading={ updateFoodPartnerOrderStatus?.loading }
                    >
                        Zmień status na "dostarczone"
                    </SubmitButton>
                )
            }
            {
                foodPartnerOrderStatus === FoodPartnerOrderStatusEnum.DELIVERED.value && (
                    <SubmitButton
                        type="button"
                        onClick={ () => onUpdateFoodPartnerOrderStatus(FoodPartnerOrderStatusEnum.IN_PROGRESS.value) }
                        isLoading={ updateFoodPartnerOrderStatus?.loading }
                    >
                        Zmień status na "w realizacji"
                    </SubmitButton>
                )
            }
        </Stack>
    );
};

export default UpdateStatusButtons;